import "./App.css";
import { MainImage } from "./components/MainImage";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { Contents } from "./components/Contents";
import { SideBar } from "./components/SideBar";

const Wrapper = styled.div`
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  background-color: white;
`;

function App() {

  const [showContent, setShowContent] = useState(false);
   useEffect(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  }, []);
  return (
    <div
      className="App"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
        backgroundImage: "url(/bg/bgpaper.jpeg)",
        backgroundSize: "contain",
        backgroundRepeat: "repeat",
        backgroundPosition: "center",
      }}
    >
      <Wrapper>
        {showContent ? (
          <Contents />
        ) : (
          <MainImage
            enter={() => {
              setShowContent(true);
            }}
          />
        )}
      </Wrapper>
      <SideBar show={showContent} />
    </div>
  );
}

export default App;
